import { Cubby } from "../Cubby";

export const highestOutboundChannelBalance = (cubby: Cubby) => {
  const possibleChannels = cubby.channelsList?.data.filter(
    (channel) => channel.synthetic_status === "open" && channel.is_active
  );

  if (!possibleChannels || possibleChannels.length === 0) {
    return 0; // or any other default value you prefer
  }

  const highestBalanceChannel = possibleChannels.reduce((maxChannel, channel) =>
    channel.local_balance > maxChannel.local_balance ? channel : maxChannel
  );

  return (
    highestBalanceChannel.local_balance - highestBalanceChannel.local_reserve
  );
};

export const unclosedChannelsOpenedByUser = (cubby: Cubby) => {
  return (
    cubby.channelsList?.data?.filter(
      (channel) =>
        channel.is_partner_initiated == false &&
        channel.synthetic_status !== "closed"
    ) || null
  );
};
